export const POST_ASSET_EVENT_NAME = 'PostAssetGroupEvent';

export const AssetEventRecordType = {
  ENTER_FLOW: 'EnterFlow',
  RETURNED: 'Returned',
  VIEWED: 'Viewed',
  APPLIED: 'Applied',
  FEATURE_USAGE: 'FeatureUsage',
};

export const AssetEventOperationName = {
  NON_ITERATIVE: 'NonIterative',
  REFRESH_THEME: 'RefreshTheme',
  DIFFERENT_BACKGROUND: 'DifferentBackground',
  REWRITE: 'Rewrite',
  FIND_SIMILAR: 'FindSimilar',
  DIFFERENT_TONE: 'DifferentTone',
  FINAL_URL_RECOMMENDATION: 'FinalUrlRecommendation',
};

export const AssetEventFeature = {
  DisplayPlus: 'DisplayPlus',
  DisplayPlusCreative: 'DisplayPlusCreative',
  RSA: 'RSA',
  PMAX: 'Pmax',
};

export const AssetType = {
  TEXT: 'Text',
  IMAGE: 'Image',
  THEME: 'Theme',
};
export const AssetChannel = {
  WEB_UI: 'bingadsweb',
};

export const AssetScenario = {
  CREATE_WORK_FLOW: 'CreateWorkFlow',
  EDIT_WORK_FLOW: 'EditWorkFlow',
};
